<template>
  <v-row class="main-container">
    <!-- <dialog-manage-invoice
      :dialog="dialogManageInvoice"
      v-model="selectedInvoice"
      v-on:dialog-close="onDialogClose"
    ></dialog-manage-invoice> -->

    <!-- Dialog filter shipment list -->
    <v-dialog v-model="dialogFilterShipment" max-width="900">
      <v-card flat tile color="white">
        <v-card-title class="dialog-header-title"
          >Filter shipment list</v-card-title
        >

        <v-card-text class="py-1 px-1">
          <v-row justify="center" class="py-2">
            <v-btn-toggle
              class="v-btn-toggle-new-quotation"
              mandatory
              dense
              v-model="selectedShipmentStatusFilter"
            >
              <v-btn text :value="0">All</v-btn>
              <v-btn text :value="1">In progress</v-btn>
              <v-btn text :value="2">Complete</v-btn>
              <v-btn text :value="3">To invoice</v-btn>
            </v-btn-toggle>
          </v-row>

          <v-row>
            <v-divider class="mt-0"></v-divider>
          </v-row>

          <v-row>
            <v-col cols="2">
              <span>Shipment type:</span>
              <v-select
                class="form-control rounded-0"
                placeholder="type"
                :items="shipmentTypeFilters"
                solo
                v-model="selectedShipmentTypeFilter"
                clearable
                clear-icon="mdi-close"
              ></v-select>
            </v-col>

            <v-col>
              <span>Origin port:</span>
              <v-autocomplete
                class="form-control rounded-0"
                solo
                placeholder="Select origin port"
                :items="sortedPortList"
                item-text="label"
                item-value="un_code"
                clearable
                v-model="selectedOriginPortFilter"
              >
                <template v-slot:item="data">
                  <v-list-item-content style="font-size: 90%">
                    <v-list-item-title
                      v-html="data.item.label"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-slot:item="data">
                  <img
                    :src="CONSTANT.getFlag(data.item.code_country)"
                    class="country-flag"
                  />
                  <v-list-item-content style="font-size: 90%">
                    <v-list-item-title
                      v-html="data.item.label"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col>
              <span>Destination port:</span>
              <v-autocomplete
                class="form-control rounded-0"
                solo
                placeholder="Select destination port"
                :items="sortedPortList"
                item-text="label"
                item-value="un_code"
                clearable
                v-model="selectedDestPortFilter"
              >
                <template v-slot:item="data">
                  <v-list-item-content style="font-size: 90%">
                    <v-list-item-title
                      v-html="data.item.label"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-slot:item="data">
                  <img
                    :src="CONSTANT.getFlag(data.item.code_country)"
                    class="country-flag"
                  />
                  <v-list-item-content style="font-size: 90%">
                    <v-list-item-title
                      v-html="data.item.label"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-divider class="mt-3"></v-divider>
          </v-row>

          <v-row>
            <v-col class="mr-4">
              <span>Company:</span>
              <v-autocomplete
                v-if="$root.is_admin"
                class="form-control rounded-0"
                :items="sortedCompanies"
                placeholder="Select Company Name"
                return-object
                v-model="selectedCompany"
                clearable
                item-text="name"
                solo
              ></v-autocomplete>
            </v-col>

            <v-col cols="3">
              <span class="pt-2 mr-2 black--text">Filter by:</span>
              <v-select
                class="form-control rounded-0"
                placeholder="Select date filter"
                :items="dateRangeFilters"
                item-text="label"
                item-value="id"
                solo
                v-model="selectedDateRangeFilter"
                clearable
                clear-icon="mdi-close"
                style="width: 100%"
              ></v-select>
            </v-col>

            <v-col cols="2">
              <span class="pt-2 mr-2 black--text">Start date:</span>
              <flat-pickr
                v-model="selectedStartFilter"
                placeholder="Select date"
                :config="config"
                name="date"
              ></flat-pickr>
            </v-col>

            <v-col cols="2">
              <span class="pt-2 mr-2 black--text">End date:</span>
              <flat-pickr
                v-model="selectedEndFilter"
                placeholder="Select date"
                :config="config"
                name="date"
              ></flat-pickr>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="my-1"></v-divider>

        <v-card-actions>
          <v-row justify="end">
            <v-btn
              color="primary"
              small
              tile
              depressed
              class="font-weight-bold mr-2"
              @click="onLoadFilteredShipmentList"
              >LOAD</v-btn
            >

            <v-btn
              color="error"
              small
              tile
              depressed
              class="font-weight-bold ml-2"
              @click="onCloseDialogShipmentFilter"
              >CLOSE</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <v-row no-gutters class="px-2">
      <v-col>
        <v-subheader class="headline pl-0 ml-0" style="color: #1976d2"
          >Shipments</v-subheader
        >
      </v-col>
    </v-row>

    <v-row>
      <v-divider class="mt-0"></v-divider>
    </v-row>

    <v-row dense>
      <v-col>
        <af-pagination
          v-model="pagination"
          v-on:next="onNextPage"
          v-on:prev="onPrevPage"
          v-on:rows-per-page-change="onitemsPerPageChange"
        ></af-pagination>
      </v-col>

      <v-col cols="1" class="pr-2">
        <v-row justify="end">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                small
                class="mr-2"
                @click="onOpenDialogFilterShipment"
              >
                <v-icon size="30" color="primary">{{
                  isResetFilter ? "mdi-filter-menu-outline" : "mdi-filter-menu"
                }}</v-icon>
              </v-btn>
            </template>
            Filter shipment list
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                tile
                depressed
                icon
                color="primary"
                @click="onResetRefreshShipmentList"
              >
                <v-icon size="30">mdi-refresh</v-icon>
              </v-btn>
            </template>
            Reset filter
          </v-tooltip>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-divider class="mt-1"></v-divider>
    </v-row>

    <v-row no-gutters class="px-2">
      <v-col cols="12" v-if="!empty_shipment_list">
        <template v-for="(item, i) in shipmentsTableView">
          <v-row :key="i" no-gutters v-if="item.booking_confirmed">
            <v-col>
              <v-card tile flat color="white" class="elevation-3">
                <v-expansion-panels tile style="border: none">
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      class="rounded-0 pl-1 pr-2 py-1"
                      :color="
                        item.shipment_workflow.completed && !item.issued_invoice
                          ? 'amber lighten-4'
                          : item.shipment_workflow.completed
                          ? 'green lighten-5'
                          : 'white'
                      "
                    >
                      <v-row no-gutters>
                        <v-col>
                          <v-row justify="start">
                            <span
                              class="
                                font-weight-black
                                caption
                                black--text
                                pt-1
                                mr-3
                              "
                            >
                              <v-icon size="20" color="primary">{{
                                getShipmentType(item).icon
                              }}</v-icon>
                              {{ item.shipment_order_id }}
                            </span>

                            <v-chip
                              x-small
                              class="
                                px-1
                                mx-1
                                mt-1
                                chip-x-small-custom
                                overline
                              "
                              label
                              outlined
                              :color="getTransactionType(item).color"
                              >{{ getTransactionType(item).title }}</v-chip
                            >

                            <v-chip
                              x-small
                              class="
                                px-1
                                mx-1
                                mt-1
                                chip-x-small-custom
                                overline
                              "
                              label
                              outlined
                              >{{ getShipmentType(item).title }}</v-chip
                            >

                            <v-chip
                              x-small
                              class="
                                px-1
                                mx-1
                                mt-1
                                chip-x-small-custom
                                overline
                              "
                              label
                              outlined
                              >{{ item.quotation.incoterm }}</v-chip
                            >

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  class="mx-1"
                                  :color="getCargoType(item).color"
                                  size="14"
                                  >{{ getCargoType(item).icon }}</v-icon
                                >
                              </template>
                              {{
                                item.quotation.commodity ||
                                getCargoType(item).title
                              }}
                            </v-tooltip>
                          </v-row>

                          <v-row justify="start" class="pl-6">
                            <span class="overline"
                              >BL: {{ item.misc.bill_of_lading || "N/A" }}</span
                            >
                          </v-row>

                          <!-- <v-row justify="start" class="mt-1 mb-2 pl-6">
                            <template v-for="inv in item.invoices">
                              <v-chip
                                :key="inv"
                                x-small
                                color="secondary"
                                outlined
                                label
                                ripple
                                class="pa-2 mr-2 font-weight-bold overline"
                                @click="onManageInvoice(inv)"
                                >{{ inv }}</v-chip
                              >
                            </template>
                          </v-row> -->
                        </v-col>

                        <v-col cols="2" class="px-4">
                          <template v-if="$root.is_admin">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-badge
                                  class="font-weight-bold"
                                  :content="message_count[item.quotation_id]"
                                  :value="message_count[item.quotation_id]"
                                  color="amber darken-4"
                                  overlap
                                  bordered
                                  offset-x="9"
                                  offset-y="18"
                                >
                                  <v-icon v-on="on" size="25" color="primary"
                                    >mdi-message-text</v-icon
                                  >
                                </v-badge>
                              </template>
                              Message count
                            </v-tooltip>
                          </template>
                        </v-col>

                        <v-col cols="auto" md="4" class="pr-2">
                          <v-row justify="start" class="pt-1">
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <span
                                  v-on="on"
                                  class="
                                    font-weight-bold
                                    caption
                                    black--text
                                    ml-2
                                  "
                                >
                                  <v-icon
                                    size="10"
                                    left
                                    color="primary"
                                    class="mr-0 pb-1"
                                    >mdi-checkbox-blank-circle</v-icon
                                  >
                                  {{ item.quotation.origin_port.un_code }}
                                </span>
                              </template>
                              {{ getOriginLabel(item) }}
                            </v-tooltip>

                            <span class="mx-1">----</span>

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <span
                                  v-on="on"
                                  class="font-weight-bold caption black--text"
                                >
                                  <v-icon
                                    size="10"
                                    left
                                    color="error"
                                    class="mr-0 pb-1"
                                    >mdi-checkbox-blank-circle</v-icon
                                  >
                                  {{ item.quotation.destination_port.un_code }}
                                </span>
                              </template>
                              {{ getDestinationLabel(item) }}
                            </v-tooltip>
                          </v-row>

                          <v-row justify="start" class="pl-5">
                            <span class="overline black--text pt-1">{{
                              getVesselVoyage(item)
                            }}</span>
                          </v-row>
                        </v-col>

                        <!-- <v-spacer></v-spacer> -->

                        <v-col cols="auto" md="1">
                          <v-row justify="end" class="pt-1">
                            <span
                              class="font-weight-bold caption primary--text"
                              >{{ getOriginScheduleTime(item) }}</span
                            >
                          </v-row>

                          <v-row justify="end" class="pt-1">
                            <span
                              class="font-weight-bold caption error--text"
                              >{{ getDestinationScheduleTime(item) }}</span
                            >
                          </v-row>
                        </v-col>

                        <v-col md="2">
                          <v-row no-gutters>
                            <v-col
                              v-if="
                                item.shipment_workflow.completed ||
                                item.status ==
                                  CONSTANT.STATUS.SHIPMENT_ORDER
                                    .SHIPMENT_COMPLETE
                              "
                              class="d-flex justify-end"
                            >
                              <v-chip
                                x-small
                                class="px-1 font-weight-bold caption"
                                label
                                color="green darken-2"
                                dark
                                >Completed</v-chip
                              >
                            </v-col>

                            <v-col v-else class="d-flex justify-end">
                              <template
                                v-for="(wk, id) in getCurrentWFProcess(
                                  item.shipment_workflow.workflow
                                )"
                              >
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-responsive
                                      :key="id"
                                      v-on="on"
                                      :class="`rounded-circle text-center align-center justify-center ${
                                        wk.status == 0
                                          ? 'grey'
                                          : wk.status == 1
                                          ? 'amber darken-4'
                                          : 'green darken-2'
                                      }`"
                                      height="26"
                                      max-width="26"
                                    >
                                      <v-icon size="15" color="white">{{
                                        setWorkflowIcon(item, wk.process)
                                      }}</v-icon>
                                    </v-responsive>
                                  </template>
                                  {{ wk.alias }}
                                </v-tooltip>

                                <hr
                                  :key="`hr${id}`"
                                  v-if="id == 0"
                                  :class="`hr-line mt-3 ${wk.color_1}`"
                                />
                                <hr
                                  :key="`hr${id}`"
                                  v-else-if="id == 1"
                                  :class="`hr-line mt-3 ${wk.color_2}`"
                                />
                              </template>
                            </v-col>
                          </v-row>

                          <v-row justify="end" class="pt-2">
                            <span
                              v-if="item.misc.customer_reference != null"
                              class="
                                font-weight-bold
                                caption
                                black--text
                                text-uppercase
                              "
                              >{{ item.misc.customer_reference }}</span
                            >

                            <v-spacer
                              v-if="item.misc.customer_reference != null"
                            ></v-spacer>

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <span
                                  v-on="on"
                                  v-if="$root.is_admin"
                                  style="max-width: 160px; font-size: 10px"
                                  class="
                                    d-inline-block
                                    text-truncate
                                    font-weight-bold
                                    text-uppercase
                                  "
                                  >{{
                                    item.company.short_name || item.company.name
                                  }}</span
                                >
                              </template>
                              {{ item.company.name }}
                            </v-tooltip>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content
                      :color="
                        item.shipment_workflow.completed
                          ? 'white'
                          : 'grey lighten-5'
                      "
                    >
                      <shipment-workflow-view
                        :shipment="item"
                        :color="
                          item.shipment_workflow.completed ? 'white' : '#FAFAFA'
                        "
                        v-on:remove-shipment="removeShipment(item)"
                      ></shipment-workflow-view>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-col>
          </v-row>

          <v-divider :key="`${i}divider`" class="my-1"></v-divider>
        </template>
      </v-col>

      <v-col v-else class="mt-10 pa-10">
        <v-alert tile dense prominent type="error">
          <v-row align="center">
            <v-col v-if="selectedCompany != null" class="grow">
              <strong>{{ selectedCompany.name }}</strong> does not have any
              Shipment yet
            </v-col>
            <v-col v-else class="grow">Shipment list is empty</v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import constant from "../../const"
import moment from "moment"
import flatPickr from "vue-flatpickr-component"
import "flatpickr/dist/flatpickr.css"
import "flatpickr/dist/themes/airbnb.css"
import ShipmentWorkflowView from "@/components/shared/ShipmentWorkflowView.vue"
import DialogManageInvoice from "@/components/admin/dialogs/DialogManageInvoice"
import AFPagination from "@/components/shared/AFPagination"

export default {
  components: {
    flatPickr,
    ShipmentWorkflowView,
    DialogManageInvoice,
    "af-pagination": AFPagination,
  },

  data() {
    return {
      // CONSTANT
      CONSTANT: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      alert: false,
      alertType: "success",
      alertMessage: "",

      config: {
        altInput: true,
        altInputClass: "flatpickr-alt-input-filter",
        // enableTime: true,
        altFormat: "M j, Y",
        dateFormat: "Y-m-d",
        // time_24hr: true,
        position: "auto",
      },

      companies: [],
      selectedCompany: null,
      empty_shipment_list: false,

      shipment_info_menu: false,

      dialogManageInvoice: false,
      selectedInvoice: null,

      pagination: {
        sortBy: ["shipment_order_id"],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 20,
        totalItems: 0,
      },

      shipments: [],
      shipmentsTableView: [],
      selectedShipment: null,

      message_count: {},

      dialogFilterShipment: false,

      shipmentTypeFilters: ["FCL", "LCL", "AIR"],
      dateRangeFilters: [
        {
          id: 0,
          label: "Cargo ready date",
        },
        {
          id: 1,
          label: "Shipment created date",
        },
      ],
      portList: [],

      selectedShipmentStatusFilter: 1,

      selectedShipmentTypeFilter: null,

      selectedOriginPortFilter: null,
      selectedDestPortFilter: null,

      selectedDateRangeFilter: null,

      selectedStartFilter: null,
      selectedEndFilter: null,

      isResetFilter: true,
    }
  },

  async created() {
    this.$root.fullScreenView = false
    this.$root.blockUImsg = "Loading shipments"
    this.$root.blockUIshow = true
    // verify user token
    await this.$root.verify_user_token()

    this.initializeFilters()
    this.initializeShipmentList(false)
  },

  watch: {},

  methods: {
    /**
     * fetch ports
     */
    async fetch_ports() {
      let resp = await this.$https.get("/api/ports")
      this.portList = resp.data.data || []
    },

    /**
     * Load companies
     */
    async loadCompanies() {
      if (this.$root.is_admin) {
        let resp = await this.$https.get("/api/company/list")
        this.companies = resp.data.data || []
      }
    },

    /**
     * Initialise the filters
     */
    async initializeFilters() {
      this.loadCompanies()
      this.fetch_ports()

      this.selectedStartFilter = moment().startOf("month").format("YYYY-MM-DD") // default to start of the current month
      this.selectedEndFilter = moment().endOf("month").format("YYYY-MM-DD") // default to end of the current month
    },

    /**
     * Reset the filters
     */
    resetFilters() {
      this.selectedCompany = null
      this.selectedShipmentStatusFilter = 1

      this.selectedShipmentTypeFilter = null

      this.selectedOriginPortFilter = null
      this.selectedDestPortFilter = null

      this.selectedDateRangeFilter = null

      this.selectedStartFilter = null
      this.selectedEndFilter = null

      this.isResetFilter = true
    },

    /**
     * On reset filters and refresh shipment list
     */
    onResetRefreshShipmentList() {
      this.resetFilters()
      this.initializeShipmentList(false)
    },

    onNextPage() {
      let isLastPageLoaded =
        this.pagination.itemsPerPage * (this.pagination.page - 1) ==
        this.shipments.length

      if (isLastPageLoaded) {
        this.initializeShipmentList(true)
      } else {
        this.refreshShipmentsViewList()
      }
    },

    onPrevPage() {
      this.refreshShipmentsViewList()
    },

    onitemsPerPageChange() {
      this.initializeShipmentList(false)
    },

    refreshShipmentsViewList() {
      this.shipmentsTableView = this.shipments.slice(
        (this.pagination.page - 1) * this.pagination.itemsPerPage,
        this.pagination.page * this.pagination.itemsPerPage
      )
    },

    /**
     * on open dialog filter shipment list
     */
    onOpenDialogFilterShipment() {
      this.dialogFilterShipment = true
    },

    initializeShipmentList(isAppend) {
      this.$root.blockUImsg = "Loading shipments"
      this.$root.blockUIshow = true

      let requestString =
        "/api/shipment_orders/list?shipment=true&limit=" +
        this.pagination.itemsPerPage

      // let requestString = "/api/shipment_orders/list?shipment=true&limit=5"

      if (isAppend && this.pagination.next_cursor != null) {
        requestString = requestString + "&cursor=" + this.pagination.next_cursor
      } else {
        this.shipments = []
        this.pagination.totalItems = 0
        this.pagination.next_cursor = null
        this.pagination.page = 1
      }

      if (this.selectedCompany != null) {
        requestString =
          requestString + "&company_id=" + this.selectedCompany.company_id
      }

      switch (this.selectedShipmentStatusFilter) {
        // in progress (#1)
        case 1:
          requestString = requestString + "&completed=false"
          break
        // complete (#2)
        case 2:
          requestString = requestString + "&completed=true"
          break
        // To invoice (#3)
        case 3:
          requestString = requestString + "&completed=true&issued_invoice=false"
          break
        default:
          break
      }

      // append the advanced filters
      // if shipment type filter selected
      if (this.selectedShipmentTypeFilter != null) {
        requestString = `${requestString}&s_type=${this.selectedShipmentTypeFilter}`
      }

      // if origin port filter selected
      if (this.selectedOriginPortFilter != null) {
        requestString = `${requestString}&op_un_code=${this.selectedOriginPortFilter}`
      }

      // if destination port filter selected
      if (this.selectedDestPortFilter != null) {
        requestString = `${requestString}&dp_un_code=${this.selectedDestPortFilter}`
      }

      // iif date range filter is not null
      if (this.selectedDateRangeFilter != null) {
        // validate start and end date
        if (
          this.selectedStartFilter == null ||
          this.selectedEndFilter == null ||
          this.selectedStartFilter.length == 0 ||
          this.selectedEndFilter.length == 0
        ) {
          this.showSnackbar = true
          this.snackbarColor = "error"
          this.snackbarMsg = "Invalid input for either start or end date"
          this.$root.blockUIshow = false
          return
        }

        if (this.selectedDateRangeFilter == 0) {
          requestString = `${requestString}&filter_by_crd=true&start_crd=${this.selectedStartFilter}&end_crd=${this.selectedEndFilter}`
        } else if (this.selectedDateRangeFilter == 1) {
          requestString = `${requestString}&filter_by_created=true&start_crd=${this.selectedStartFilter}&end_crd=${this.selectedEndFilter}`
        }
      }

      this.$https
        .get(requestString)
        .then((resp) => {
          var response = resp.data
          if (response.status == constant.RESPONSE_STATUS_OK) {
            this.empty_shipment_list = false

            // initialise the message count object
            response.data.data.forEach((element) => {
              this.$set(this.message_count, element.shipment_order_id, 0)
            })

            this.shipments.push(...response.data.data)
            if (response.data.count > 0) {
              this.pagination.totalItems = response.data.count
            }
            this.pagination.next_cursor = response.data.next_cursor

            this.refreshShipmentsViewList()
            this.$root.blockUIshow = false

            // set the comment messages for each quotation
            const firestore_db = this.$root.messageCenterApp.firestore()
            response.data.data.forEach((element) => {
              this.setMessageCount(firestore_db, element)
            })
          } else if (response.status == constant.RESPONSE_STATUS_EMPTY) {
            this.empty_shipment_list = true
            this.$root.blockUIshow = false
          } else {
            console.log("Error loading shipments list", response)
            this.showSnackbar = true
            this.snackbarColor = "error"
            this.snackbarMsg = response.msg
            this.$root.blockUIshow = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.showSnackbar = true
          this.snackbarColor = "error"
          this.snackbarMsg = err
          this.$root.blockUIshow = false
        })
    },

    /**
     * Get the shipment type
     * @param {object} shipment
     */
    getShipmentType(shipment) {
      var color = "error"
      var title = ""
      var icon = "mdi-alert-circle"

      switch (shipment.quotation_type) {
        case constant.QUOTATION_TYPE_SEA_FCL:
          color = "light-blue darken-4"
          title = "FCL"
          icon = "mdi-ferry"

          if (shipment.quotation.containers.length == 1) {
            if (shipment.quotation.containers[0].container_size == 20) {
              title = "F20'"
            } else if (shipment.quotation.containers[0].container_size == 40) {
              title = "F40'"
            }
          } else {
            let csizes = []
            shipment.quotation.containers.forEach((container) => {
              csizes.push(`F${container.container_size}'`)
            })
            title = `${csizes.join(" | ")}`
          }
          break
        case constant.QUOTATION_TYPE_SEA_LCL:
          color = "accent"
          title = "LCL"
          icon = "mdi-ferry"
          break
        case constant.QUOTATION_TYPE_AIR:
          color = "secondary"
          title = "AIR"
          icon = "mdi-airplane-takeoff"
          break
        case constant.QUOTATION_TYPE_WAREHOUSE:
          color = "blue-grey"
          title = "WH"
          icon = "mdi-warehouse"
          break
        default:
          break
      }

      return { icon: icon, color: color, title: title }
    },

    /**
     * Get the cargo type
     * @param {object} shipment
     */
    getCargoType(shipment) {
      var color = "brown"
      var title = ""
      var icon = "fa-box"

      switch (shipment.quotation.cargo_type_code) {
        case "DG-2":
          title = shipment.quotation.cargo_type_code + ": Gases"
          color = "deep-orange lighten-1"
          icon = "fa-burn"
          break
        case "DG-3":
          title = shipment.quotation.cargo_type_code + ": Flammable liquids"
          color = "error"
          icon = "fa-fire"
          break
        case "NON-DG":
          title = shipment.quotation.cargo_type_code + ": Non dangerous goods"
          color = "brown lighten-1"
          break
      }

      return { icon: icon, color: color, title: title }
    },

    /**
     * Get the transaction type
     * @param {object} shipment
     */
    getTransactionType(shipment) {
      var color = ""
      var title = ""

      if (shipment.quotation.transaction_type == "EXPORT") {
        color = "#8F2D56"
        title = "EXP"
      } else if (shipment.quotation.transaction_type == "IMPORT") {
        color = "#3CAEA3"
        title = "IMP"
      }

      return { color: color, title: title }
    },

    /** get vessel name and voyage */
    getVesselVoyage(shipment) {
      let ret = `${shipment.quotation.shipment_schedule.vessel_name || ""}`

      if (shipment.quotation.shipment_schedule.vessel_voyage != null) {
        ret = `${shipment.quotation.shipment_schedule.vessel_name || ""}, ${
          shipment.quotation.shipment_schedule.vessel_voyage
        }`
      }
      return ret
    },

    /**
     * get the origin schedule time
     */
    getOriginScheduleTime(shipment) {
      let line = "ETA: N/A"
      // use ETD for Air
      if (shipment.quotation_type == constant.QUOTATION_TYPE_AIR) {
        line = "ETD: N/A"

        // if atd
        if (shipment.quotation.shipment_schedule.origin_atd != null) {
          // if atd
          line = `ATD: ${
            shipment.quotation.shipment_schedule.origin_atd_string || "N/A"
          }`
        } else if (shipment.quotation.shipment_schedule.origin_etd != null) {
          // if etd
          line = `ETD: ${
            shipment.quotation.shipment_schedule.origin_etd_string || "N/A"
          }`
        }
      } else {
        line = "ETA: N/A"

        // if atd
        if (shipment.quotation.shipment_schedule.origin_atd != null) {
          // if atd
          line = `ATD: ${
            shipment.quotation.shipment_schedule.origin_atd_string || "N/A"
          }`
        } else if (shipment.quotation.shipment_schedule.origin_eta != null) {
          line = `ETA: ${
            shipment.quotation.shipment_schedule.origin_eta_string || "N/A"
          }`
        }
      }
      return line
    },

    /**
     * get the destination schedule time
     */
    getDestinationScheduleTime(shipment) {
      let line = "ETA: N/A"

      // if ata is not null, then use the Actual Time of arrival
      if (shipment.quotation.shipment_schedule.destination_ata != null) {
        line = `ATA: ${
          shipment.quotation.shipment_schedule.destination_ata_string || "N/A"
        }`
      } else if (shipment.quotation.shipment_schedule.destination_eta != null) {
        line = `ETA: ${
          shipment.quotation.shipment_schedule.destination_eta_string || "N/A"
        }`
      }
      return line
    },

    /**
     * on manage invoice
     */
    async onManageInvoice(invoice_id) {
      // // only admin can open this dialog
      // if (this.$root.is_admin) {
      //   this.$root.blockUImsg = "Loading invoice information";
      //   this.$root.blockUIshow = true;
      //   // verify user token
      //   await this.$root.verify_user_token();
      //   let resp = await this.$https.get(`/api/invoices/${invoice_id}`);
      //   if (resp.data.status == constant.RESPONSE_STATUS_OK) {
      //     this.selectedInvoice = resp.data.data;
      //     this.dialogManageInvoice = true;
      //   } else {
      //     console.log("OnManageInvoice Error: ", resp.data);
      //   }
      //   this.$root.blockUIshow = false;
      // }
    },

    /**
     * Get current workflow status
     */
    getCurrentWFProcess(workflow) {
      // 0: pending, 1: in progress, 2: completed

      //* first process
      let first_process = "empty"
      let fp_alias = "Error!"
      let fp_status = 0

      //* second process
      let second_process = "empty"
      let sp_alias = "Error!"
      let sp_status = 0

      //* third process
      let third_process = "empty"
      let tp_alias = "Error!"
      let tp_status = 0

      let line_color_1 = "grey"
      let line_color_2 = "grey"

      // form the included processes
      let inc_workflow = []
      workflow.forEach((item) => {
        // select only the included process
        if (item.included) {
          inc_workflow.push(item)
        }
      })

      let len = inc_workflow.length

      // find the current process
      for (let i = 0; i < len; i++) {
        // count the index backwards omitting the last two processes
        let index = len - 3 - i

        // if index is < 0 then break the loop
        if (index < 0) {
          break
        }

        // get the included workflow process item from the back
        const item = inc_workflow[index]

        // if the current process is completed
        if (item.meta_data.end.status) {
          // set the current process as the first process
          first_process = item.process
          fp_alias = item.alias
          fp_status = 2

          // set the next process as the second process
          let second = inc_workflow[index + 1]
          second_process = second.process
          sp_alias = second.alias
          sp_status =
            !second.meta_data.start.status && !second.meta_data.end.status
              ? 0
              : second.meta_data.start.status && !second.meta_data.end.status
              ? 1
              : 2
          line_color_1 =
            !second.meta_data.start.status && !second.meta_data.end.status
              ? "grey"
              : second.meta_data.start.status && !second.meta_data.end.status
              ? "amber darken-4"
              : "green darken-2"

          // set the second next process as the third process
          let third = inc_workflow[index + 2]
          third_process = third.process
          tp_alias = third.alias
          tp_status = third.meta_data.start.status ? 1 : 0
          line_color_2 = third.meta_data.start.status
            ? "amber darken-4"
            : "grey"
          break
        }

        // if the current process is in progress
        else if (item.meta_data.start.status && !item.meta_data.end.status) {
          // if the current status is the first process
          if (index == 0) {
            // set the current process as the first process
            first_process = item.process
            fp_alias = item.alias
            fp_status = 1

            // set the next process as the second process
            let second = inc_workflow[index + 1]
            second_process = second.process
            sp_alias = second.alias
            sp_status = 0
            line_color_1 = "grey"

            // set the second next process as the third process
            let third = inc_workflow[index + 2]
            third_process = third.process
            tp_alias = third.alias
            tp_status = 0
            line_color_2 = "grey"
            break
          } else {
            // set the previous process as the first process
            let prev = inc_workflow[index - 1]
            first_process = prev.process
            fp_alias = prev.alias
            fp_status = prev.meta_data.end.status
              ? 2
              : prev.meta_data.start.status
              ? 1
              : 0

            // set the current process as the second process
            second_process = item.process
            sp_alias = item.alias
            sp_status = 1
            line_color_1 = "amber darken-4"

            // set the next process as the third process
            let third = inc_workflow[index + 1]
            third_process = third.process
            tp_alias = third.alias
            tp_status = third.meta_data.start.status ? 1 : 0
            line_color_2 = third.meta_data.start.status
              ? "amber darken-4"
              : "grey"
            break
          }
        }

        // if no process has started
        else if (!item.meta_data.start.status && !item.meta_data.end.status) {
          // set the current process as the first process
          first_process = item.process
          fp_alias = item.alias
          fp_status = 0

          // set the next process as the second process
          let second = inc_workflow[index + 1]
          second_process = second.process
          sp_alias = second.alias
          sp_status = 0
          line_color_1 = "grey"

          // set the second next process as the third process
          let third = inc_workflow[index + 2]
          third_process = third.process
          tp_alias = third.alias
          tp_status = 0
          line_color_2 = "grey"
        }
      }

      let ret = [
        {
          process: first_process,
          alias: fp_alias,
          status: fp_status,
          color_1: line_color_1,
          color_2: line_color_2,
        },
        {
          process: second_process,
          alias: sp_alias,
          status: sp_status,
          color: line_color_1,
          color_2: line_color_2,
        },
        {
          process: third_process,
          alias: tp_alias,
          status: tp_status,
          color_1: line_color_1,
          color_2: line_color_2,
        },
      ]

      return ret
    },

    /**
     * Set the workflow icon
     */
    setWorkflowIcon(shipment, process) {
      let icon = constant.WORKFLOW_FORMAT[process].icon
      if (shipment.quotation_type == constant.QUOTATION_TYPE_AIR) {
        if (process == "vessel_departure") {
          icon = "mdi-airplane-takeoff"
        } else if (process == "vessel_in_transit") {
          icon = "mdi-airplane mdi-rotate-90"
        } else if (process == "vessel_arrival") {
          icon = "mdi-airplane-landing"
        }
      }
      return icon
    },

    /**
     * Get origin port label
     */
    getOriginLabel: function (shipment) {
      if (
        shipment.quotation_type == constant.QUOTATION_TYPE_SEA_FCL ||
        shipment.quotation_type == constant.QUOTATION_TYPE_SEA_LCL ||
        shipment.quotation_type == constant.QUOTATION_TYPE_AIR
      ) {
        return shipment.quotation.origin_port.name
      } else {
        return ""
      }
    },

    /**
     * Get destination port label
     */
    getDestinationLabel: function (shipment) {
      if (
        shipment.quotation_type == constant.QUOTATION_TYPE_SEA_FCL ||
        shipment.quotation_type == constant.QUOTATION_TYPE_SEA_LCL ||
        shipment.quotation_type == constant.QUOTATION_TYPE_AIR
      ) {
        return shipment.quotation.destination_port.name
      } else {
        return ""
      }
    },

    /**
     * Set the comment message count for each shipment
     */
    setMessageCount(firestore_db, shipment) {
      // Get the message count and listen to the document
      firestore_db
        .collection("comments")
        .doc(shipment.shipment_order_id)
        .onSnapshot((doc) => {
          if (!doc.exists) {
            this.message_count[shipment.shipment_order_id] = 0
            // console.error("doc doesnt exist");
          } else {
            // get the message count number
            this.message_count[shipment.shipment_order_id] = doc.data().count
          }
        })
    },

    /**
     * On remove shipment that been deleted
     */
    removeShipment(shipment) {
      // shipment.status = constant.STATUS.SHIPMENT_ORDER.DELETED;

      this.shipmentsTableView = this.shipmentsTableView.filter((item) => {
        return item != shipment
      })
    },

    /**
     * on load filtered shipment list
     */
    onLoadFilteredShipmentList() {
      this.isResetFilter = false
      this.dialogFilterShipment = false
      this.initializeShipmentList(false)
    },

    /**
     * on close the dialog shipment list filter
     */
    onCloseDialogShipmentFilter() {
      this.dialogFilterShipment = false
    },

    onDialogClose(dialogID, quotation, hasChange) {
      switch (dialogID) {
        case constant.DIALOG_MANAGE_INVOICE:
          this.dialogManageInvoice = false
          break
      }

      this.selected_tbc_quotation = null
      this.selectedBookingInfo = null
      this.selectedQuotation = null
      this.selectedShipmentId = null
      this.selectedCompanyId = null
      this.selectedInvoice = null
    },
  },

  computed: {
    sortedCompanies: function () {
      return this.companies.sort(function (a, b) {
        return a.name.localeCompare(b.name)
      })
    },

    sortedPortList: function () {
      return this.portList.sort(function (a, b) {
        return a.label.localeCompare(b.label)
      })
    },
  },
}
</script>

<style scoped>
.shipment-button {
  margin-bottom: 1px;
  /* width: 180px;
  height: 30px !important; */
}

.container.grid-list-lg .layout .flex.shipment-map-container {
  border-left: 1px solid grey;
  padding: 0px 5px;
}

::v-deep .v-stepper__step__step {
  width: 30px;
  height: 30px;
  border-radius: 100%;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0 0px 0px;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  max-width: 100%;
}

.v-divider.custom-divider {
  display: block;
  -webkit-box-flex: 1;
  -ms-flex: 1 1 0px;
  flex: 1 1 0px;
  max-width: 100%;
  height: 0;
  max-height: 0;
  border: solid;
  border-width: 1px;
  -webkit-transition: inherit;
  transition: inherit;
}

.v-chip.v-size--x-small.chip-x-small-custom {
  font-weight: bold;
  height: 15px;
  width: 33px;
}

hr.hr-line {
  border: 1px solid grey;
  width: 20px;
}
</style>
